import React from 'react'
import "../css/Information.css"
const Information = () => {
  return (
      <div className="Information">
          <div className="information-container container padding">
              <h1>
                  El <b>único curso</b> de Libel en el que podrás <b>descargar las clases.</b>
              </h1>
          </div>
      </div>
  );
}

export default Information